import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAIL, 
  AUTH_AMANAH_SUCCESS, 
  AUTH_AMANAH_FAIL, 
  AUTH_AMANAH_REQUEST,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  VERIFY_RESET_CODE_REQUEST,
  VERIFY_RESET_CODE_SUCCESS,
  VERIFY_RESET_CODE_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
} from "../actions/auth";

const initialState = {
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {},
  username: "",
  notifications: {},
  loggedIn: false,
  loading: false,
  // Password reset states
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  forgotPasswordError: null,
  verifyCodeLoading: false,
  verifyCodeSuccess: false,
  verifyCodeError: null,
  resetPasswordLoading: false,
  resetPasswordSuccess: false,
  resetPasswordError: null,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN_REQUEST:
    case AUTH_AMANAH_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loginFailed: false,
        loading: true
      };

    case AUTH_LOGIN_SUCCESS:
    case AUTH_AMANAH_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loggingIn: false,
        loginFailed: false,
        loggedIn: true,
        loading: false,
      };    case AUTH_LOGIN_FAIL:
    case AUTH_AMANAH_FAIL:
      return {
        ...state,
        ...action.payload,
        loggingIn: false,
        loggedIn: false,
        loading: false
      };

    // Password reset cases
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordLoading: true,
        forgotPasswordSuccess: false,
        forgotPasswordError: null,
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: true,
        forgotPasswordError: null,
      };

    case FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: false,
        forgotPasswordError: action.payload.error,
      };

    case VERIFY_RESET_CODE_REQUEST:
      return {
        ...state,
        verifyCodeLoading: true,
        verifyCodeSuccess: false,
        verifyCodeError: null,
      };

    case VERIFY_RESET_CODE_SUCCESS:
      return {
        ...state,
        verifyCodeLoading: false,
        verifyCodeSuccess: true,
        verifyCodeError: null,
      };

    case VERIFY_RESET_CODE_FAIL:
      return {
        ...state,
        verifyCodeLoading: false,
        verifyCodeSuccess: false,
        verifyCodeError: action.payload.error,
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordSuccess: false,
        resetPasswordError: null,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: true,
        resetPasswordError: null,
      };

    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: false,
        resetPasswordError: action.payload.error,
      };

    default:
      return state;
  }
}
